import React from 'react';
import { whyProsafe } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';

const WhyProsafe = () => {
  const { t } = useLanguage();
  const reasons = t('whyProsafe.reasons');
  
  return (
    <section className="bg-[#e21b1b] py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Image - fixed size, doesn't scale up */}
          <div className="relative flex justify-center lg:justify-start">
            <div className="w-full max-w-md overflow-hidden shadow-2xl">
              <div className="aspect-[4/3]">
                <img
                  src={whyProsafe.image}
                  alt="Brandbeveiliging inspectie"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-4 border-white/20 -z-10 hidden lg:block" />
          </div>

          {/* Content */}
          <div className="lg:pl-8">
            <h2 className="font-montserrat font-black text-white text-2xl sm:text-3xl lg:text-4xl mb-8 leading-tight">
              {t('whyProsafe.title')}
            </h2>
            <div className="space-y-4">
              {reasons.map((reason, index) => (
                <div
                  key={index}
                  className="flex items-start space-x-4 group"
                >
                  <span className="flex-shrink-0 w-8 h-8 bg-white text-[#e21b1b] font-montserrat font-bold flex items-center justify-center text-lg group-hover:bg-[#1a1a1a] group-hover:text-white transition-colors duration-300">
                    {index + 1}
                  </span>
                  <p className="font-roboto text-white text-base sm:text-lg leading-relaxed pt-1">
                    {reason}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyProsafe;
